<ng-container *ngIf="isVisible">
    <img
        [id]="field.id"
        [matTooltip]="field.tooltip ? (field.tooltip | translate) : ''"
        [ngClass]="[field.panelClass, isReadOnly || field.disabled ? 'disable-field' : '']"
        [attr.aria-disabled]="isReadOnly || field.disabled"
        [ngSrc]="field.imgSrc"
        [alt]="field.imgAlt || ''"
        [height]="field.imgHeight || 24"
        [width]="field.imgWidth || 24"
        (click)="onImageAction($event)"
    />
</ng-container>
